import React, { Component } from 'react';
import ActionTypes from '../../inc/ActionsTypes';
import {connect} from 'react-redux';
import SimpleLoading from '../Loading/SimpleLoading';
import Api from '../../inc/Api';
import Settings from '../../inc/Settings';
import { Navigate } from "react-router-dom";
import Header from '../Header/Header';
import Sidebar from '../Header/Sidebar';
import Helper from '../../inc/Helper'; 
import {Helmet} from "react-helmet";
import ThemeSettings from '../../inc/ThemeSettings'; 

class MasterComonent extends Component {
    constructor(props){
        super(props);
        this.isTenantSettingLoaded = false;
        this.isVendorDetailsCalled = false;
        this.state = {
            isUserChecked:false,
        }
    }
    componentDidMount(){  
        let api = Api;
        let auth = this.props.auth;
        let that = this; 
        if(!auth.isLogin && api.getUserToken()){
            api.setJsonHeader();
            api.setUserToken();
            api.axios().get(Settings.apiUrl+'/auth/user/me/',{}).then(function(loginResponse){
                if(loginResponse && loginResponse?.status === 200){ 
                    that.props.setUser(loginResponse?.data);
                }else {
                    that.props.logOut()
                } 
                that.setState({
                    isUserChecked:true
                })
            }).catch(error => {
                that.props.logOut();
            })
        } else {
            that.setState({
                isUserChecked:true
            })
        } 
        this.loadUserSettings();
    } 
    loadUserSettings(){
        this.loadUserDateFormate(); 
    }
    loadUserDateFormate(){
        let dateFormateString = Helper.getCookie(Settings.dateFormateKey) ? Helper.getCookie(Settings.dateFormateKey) : Settings.defaultDateFormate;
        this.props.setDateFormate(dateFormateString);
    }
    getWrapperClass (reqClsssName = ''){
        if(this.props.masterClassName){
            return reqClsssName+' '+ this.props.masterClassName;
        }
        return reqClsssName;
    }
    render() {
        const props = this.props;
        if(!props.auth.isLogin && this.state.isUserChecked){
            return <Navigate to="/login"/>
        }else if(!props.auth.isLogin){ 
            return <SimpleLoading/>
        }else{ 
            return (
                <div className={this.getWrapperClass("app_master_area")}> 
                    <div className='sidebar_contact_wrapper'>
                        <Sidebar/>
                        <div className='contents_with_header'>
                            <Header/>
                            <div className='rs_master_canvas_wraper'>
                                <div className='rs_master_canvas'>
                                    { props.children }
                                    <div className='clearfix'></div>
                                </div>
                            </div>
                            
                            <div className='clearfix'></div>
                        </div>
                        <div className='clearfix'></div>
                    </div>
                </div>
            );
        }
    }
}
const mapStateToProps = (state) => {
    return {
        auth:state.auth, 
        theme:state.theme,
        appOptions:state.options
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut:() => { dispatch({type:ActionTypes.SET_LOGOUT}) },
        setDateFormate:(formate) => { dispatch({type:ActionTypes.SET_DATE_FORMATE , payload:formate}) },
        setUser:(user) => { dispatch({type:ActionTypes.SET_USER , payload:user}) },
        setAuthLoadState:(loadState) => { dispatch({type:ActionTypes.SET_AUTH_LOADING , payload:loadState}) },
        setTheme: (themeName,settings) => { dispatch({ type:ActionTypes.SET_THEME_SETTINGS,settings:settings,theme: themeName})} 
    }
}
export default connect (mapStateToProps,mapDispatchToProps) ( MasterComonent);